import React from "react";

import { Wrapper, Inside } from "./styles";

function Warning() {
  return (
    <Wrapper>
      <Inside href="https://www.mica.edu/campus-operating-status-updates/coronavirus/coronavirus-updates/" target="_blank">
        MICA is committed to keeping our community up to date with the latest campus news and information during the COVID-19 global health crisis. →
      </Inside>
    </Wrapper>
  );
}

export default Warning;



// WEBPACK FOOTER //
// ./src/components/Warning/Warning.jsx